'use strict';

angular.module('shiftTraderApp')
    .directive('saDaysOffManagementDepartmentsPane', ['TimeService', function (TimeService) {
      return {
        templateUrl: 'views/daysOff/saDaysOffManagementDepartmentsPane.html',
        restrict: 'A',
        scope: {
          me: '=',
          departments: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: ['$scope', 'DaysOffManagementModalService', 'Session',
          function($scope, DaysOffManagementModalService, Session) {
            var vm = this;

            vm.state = {
              isOpen: false,
              buttonDidToggleView: false
            };

            vm.toggleOpenState = function() {
              vm.state.isOpen = !vm.state.isOpen;

              if (vm.state.isOpen) {
                if (!DaysOffManagementModalService.getDepartmentMode()) {
                  vm.state.buttonDidToggleView = true;
                  DaysOffManagementModalService.setDepartmentMode(true);
                }
              } else {
                if (vm.state.buttonDidToggleView) {
                  DaysOffManagementModalService.setDepartmentMode(false);
                }

                vm.state.buttonDidToggleView = false;
              }
            };

            function setupDepartmentsList() {
              vm.departmentsList = _.map(vm.departments, function(dept) {
                var record = vm.departmentsData && _.find(vm.departmentsData, function(x) {
                    return dept.id === x.dept.id;
                  });

                return {
                  dept: dept,
                  numPending: record ? record.numPending : '-',
                  numApproved: record ? record.numApproved : '-',
                  numDisapproved: record ? record.numDisapproved : '-'
                };
              });
            }

            $scope.$on(DaysOffManagementModalService.departmentSummaryDataChangeEventName, function() {
              vm.departmentsData = DaysOffManagementModalService.getDepartmentsSummaryData();
              setupDepartmentsList();
            });

            _([DaysOffManagementModalService.dateChangeEventName]).each(function(eventName) {
              $scope.$on(eventName, function() {
                vm.departmentsData = null;
              });
            });

            //_([DaysOffManagementModalService.selectedDayOffChangedEventName]).each(function(eventName) {
            //  $scope.$on(eventName, function() {
            //    updatePane();
            //  });
            //});
        }]
      };
    }]);
